import { FileText } from 'lucide-react';
import { formatRange } from './utils';
import {
  formatMinor,
  TaxEmptyState,
  TaxLineRow,
  TaxReportCard,
  TaxStatCell,
  TaxStatStrip,
} from './taxReportShared';

interface ScheduleCLine {
  ref: string;
  line: string;
  displayName: string;
  totalMinor: number;
}

interface Data {
  type: string;
  periodStart: string;
  periodEnd: string;
  grossReceiptsMinor: number;
  lines: ScheduleCLine[];
  totalExpensesMinor: number;
  netProfitMinor: number;
}

export function TaxScheduleCReport({ data }: { data: Record<string, unknown> }) {
  const d = data as unknown as Data;
  const lines = (d.lines ?? []).filter((l) => l.totalMinor !== 0);

  return (
    <TaxReportCard
      icon={FileText}
      title="Schedule C — Profit or Loss"
      badge={formatRange(d.periodStart, d.periodEnd)}
    >
      <TaxStatStrip>
        <TaxStatCell label="Gross receipts" value={formatMinor(d.grossReceiptsMinor)} />
        <TaxStatCell label="Total expenses" value={formatMinor(d.totalExpensesMinor)} />
        <TaxStatCell label="Net profit" value={formatMinor(d.netProfitMinor)} emphasis />
      </TaxStatStrip>

      {lines.length === 0 ? (
        <TaxEmptyState message="No categorized Schedule C expense lines for this period." />
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-surface-50/60 text-[11px] uppercase tracking-[0.06em] text-surface-500">
              <th className="px-4.5 py-2 text-left font-medium">Expense line</th>
              <th className="px-4.5 py-2 text-right font-medium">Amount</th>
            </tr>
          </thead>
          <tbody>
            {lines.map((l) => (
              <TaxLineRow
                key={l.ref}
                label={l.displayName}
                sublabel={`L${l.line}`}
                value={formatMinor(Math.abs(l.totalMinor))}
              />
            ))}
          </tbody>
        </table>
      )}
    </TaxReportCard>
  );
}
